import { DragIndicator } from '@mui/icons-material';
import { Box, ListItem, ListItemIcon, ListItemText, Paper, Tooltip, Typography, useTheme } from '@mui/material';
import { useDrag } from 'react-dnd';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { DragAndDropTypes } from '../../model/dragAndDropTypes';

interface RuleProps {
  rule: PolicyRule;
}

const MovableListing = (props: RuleProps) => {
  const { rule } = props;
  const usePalette = useTheme().palette

  const [{ isDragging }, drag] = useDrag(() => ({
    type: DragAndDropTypes.RULELISTING,
    item: { rule },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  }));

  return (
    <Box ref={drag} style={{ opacity: isDragging ? 0.5 : 1, cursor: 'move' }}>
      <Paper>
        <Tooltip title={rule.description}>
          <ListItem component={Paper} elevation={0} sx={{backgroundColor:usePalette.secondary.main, paddingY: 0.5, borderRadius: 0.5 }}>
            <ListItemIcon>
              <DragIndicator />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
                noWrap: true
              }}
              secondaryTypographyProps={{
                sx: { overflow: 'hidden', textOverflow: 'ellipsis' },
                noWrap: true
              }}
              primary={<Typography variant={'body2'}> {rule.name} </Typography>}
              secondary={<Typography variant={'caption'}> {rule.description} </Typography>}
            />
          </ListItem>
        </Tooltip>
      </Paper>
    </Box>
  );
};

export default MovableListing;
